// Types
import Vue from 'vue';
const SeoHelper = (isPageInSections = false) => Vue.extend({
  data() {
    // There are 3 pages defined with sections so called 'Dynamic pages':
    // PageProduct
    // PageDynamic
    // PageEvent
    // All the other ones are static e.g. PageBlog, PageLogin, PageCart.. etc
    if (isPageInSections) {
      return {
        pageData: {},
        origin: null
      };
    } else {
      return {};
    }
  },
  head() {
    var _head$link;
    const head = {
      meta: [],
      link: [],
      htmlAttrs: {}
    };
    const i18nSeo = this.$nuxtI18nHead({
      addDirAttribute: true,
      addSeoAttributes: true
    });
    if (i18nSeo !== null && i18nSeo !== void 0 && i18nSeo.meta) {
      head.meta.push(...i18nSeo.meta);
    }
    if (i18nSeo !== null && i18nSeo !== void 0 && i18nSeo.link) {
      head.link.push(...i18nSeo.link);
    }
    if (i18nSeo !== null && i18nSeo !== void 0 && i18nSeo.htmlAttrs) {
      Object.assign(head.htmlAttrs, i18nSeo === null || i18nSeo === void 0 ? void 0 : i18nSeo.htmlAttrs);
    }
    if (isPageInSections) {
      const {
        seo_title,
        title,
        seo_description: description,
        seoImage: image,
        seo_follow: follow,
        seo_index: index,
        canonicalPost: canonicalUrl
      } = this.pageData;
      const finalTitle = seo_title || title;
      if (finalTitle) {
        head.title = finalTitle;
        head.meta.push({
          hid: 'og:title',
          property: 'og:title',
          name: 'og:title',
          content: finalTitle
        }, {
          hid: 'twitter:title',
          property: 'twitter:title',
          name: 'twitter:title',
          content: finalTitle
        });
      }
      if (description) {
        head.meta.push({
          hid: 'description',
          property: 'description',
          name: 'description',
          content: description
        }, {
          hid: 'og:description',
          property: 'og:description',
          name: 'og:description',
          content: description
        }, {
          hid: 'twitter:description',
          property: 'twitter:description',
          name: 'twitter:description',
          content: description
        });
      }
      let computedImageUrl = null;
      if (image) {
        const imageURL = this.$cmsMedia({
          media: image
        });
        // From 0.107.0, $cmsMedia can also return array of strings which means that there are alternative links to different file formats if user selected 'default' compression
        // where array indices will correspond to formats: 0:.avif, 1:.webp, 2:.jpeg, 3:.png
        // Safari doesnt work with avif, so in case $cmsMedia returns an array of alternative paths, we will always use the .webp one

        if (Array.isArray(imageURL) && imageURL.length) {
          computedImageUrl = imageURL.find(uri => uri.endsWith('.webp')) || null;
        } else if (this.origin && imageURL) {
          // If we didnt get an array, that means that gaussbox-gcr has to calculate image url which will be redirected (deprecated)
          computedImageUrl = `${this.origin}${imageURL}`;
        }
      } else if (!computedImageUrl) {
        computedImageUrl = this.$siteLogo;
      }
      if (computedImageUrl) head.meta.push({
        hid: 'og:image',
        property: 'og:image',
        name: 'og:image',
        content: computedImageUrl
      }, {
        hid: 'twitter:image',
        property: 'twitter:image',
        name: 'twitter:image',
        content: computedImageUrl
      });
      if (follow === 0 || index === 0) {
        const content = [];
        if (follow === 0) {
          content.push('nofollow');
        }
        if (index === 0) {
          content.push('noindex');
        }
        head.meta.push({
          hid: 'robots',
          name: 'robots',
          content: content.join(',')
        });
      }
      if (canonicalUrl) {
        head.link.push({
          rel: 'canonical',
          href: canonicalUrl
        });
      } else if (this.origin) {
        head.link.push({
          rel: 'canonical',
          href: `${this.origin}${this.$route.path}`
        });
      }
    } else {
      const {
        name
      } = this.$options;
      const title = name ? this.$t('core.page.' + name) : this.$application.domain.site.name;
      head.title = title;
      const imageUrl = this.$siteLogo;
      if (imageUrl) head.meta.push({
        hid: 'og:image',
        property: 'og:image',
        name: 'og:image',
        content: imageUrl
      }, {
        hid: 'twitter:image',
        property: 'twitter:image',
        name: 'twitter:image',
        content: imageUrl
      });
    }
    (_head$link = head.link) === null || _head$link === void 0 ? void 0 : _head$link.forEach(link => {
      var _link$href;
      const domain = this.$config.forceDomain;
      if (!((_link$href = link.href) !== null && _link$href !== void 0 && _link$href.includes(domain))) {
        link.href = 'https://' + domain + link.href;
      }
    });
    return head;
  }
});
export default SeoHelper;